export const isFieldTranslatedBySeller = ({ ugcMap }, field) => Boolean(ugcMap?.translatedBySeller?.[field]);
